import { CookieValueTypes, getCookie } from "@/lib/cookies";
import { mountStoreDevtool } from "simple-zustand-devtools";
import { create } from "zustand";

type Settings = {
  basePath: string;
  selfUrl: string;
  shopApiUri: string;
  bookingApiUri: string;
  membersApiUri: string;
  authApiUri: string;
  monitorApiUri: string;
  checkoutUrl: string;
  useBooking: boolean;
  useMobileTicket: boolean;
  useAllotment: boolean;
  posId: number;
  customer: string;
  version: string;
  environment: string;
  appUrlOverride: string;
  shopName: string;
};

export interface ConfigStore {
  theme: string;
  isStandalone: boolean;
  settings: Settings | null;
  localSettings: LocalSettings | null;
  manifestName: string | null;
  currency: CookieValueTypes | string | null;
  setCurrency: (currency: string | null) => void;
  setTheme: (newTheme: string) => void;
  setIsStandalone: (newIsStandalone: boolean) => void;
  setSettings: (newSettings: Settings) => void;
  setLocalSettings: (newLocalSettings: LocalSettings) => void;
  setManifestName: (name: string | null) => void;
}

export type HeroSettings = {
  desktop: boolean;
  mobile: boolean;
  isVideo: boolean;
};

export type LocalSettings = {
  showCourse: boolean;
  showSession: boolean;
  showProduct: boolean;
  showAllotment: boolean;
  showMobileTicket: boolean;
  showLandingHero: HeroSettings;
  showCoursesHero: HeroSettings;
  showAllotmentsHero: HeroSettings;
  showSessionsHero: HeroSettings;
  showArticleGroup: boolean;
  hideActivateTicket: boolean;
  hideLanguageSelector: boolean;
  visibleFields: string[];
  requiredFields: string[];
  plus: number[];
};

export interface LocalSettingsStore {
  localSettings: LocalSettings | null;
  setLocalSettings: (newLocalSettings: LocalSettings) => void;
}

export const useConfigStore = create<ConfigStore>((set) => ({
  isStandalone: false,
  theme: "light",
  settings: null,
  localSettings: null,
  manifestName: null,
  currency: getCookie("shop-currency"),
  setTheme: (newTheme: string) => set({ theme: newTheme }),
  setIsStandalone: (newIsStandalone: boolean) => set({ isStandalone: newIsStandalone }),
  setSettings: (newSettings: Settings) => set({ settings: newSettings }),
  setLocalSettings: (newLocalSettings: LocalSettings) => set({ localSettings: newLocalSettings }),
  setManifestName: (name: string | null) => set({ manifestName: name }),
  setCurrency: (newCurrency: string | null) => set({ currency: newCurrency })
}));

if (import.meta.env.DEV) {
  mountStoreDevtool("ConfigStore", useConfigStore);
}
